import React, {useContext, useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";

import SearchBar from "components/List/components/SearchBar";

import SidebarHeadingTitle from "../../SidebarHeadingTitle";
import OrganizationList from "./OrganizationList";
import NoOrganizationFound from "./NoOrganizationFound";
import CurrentOrganizationInfos from "./CurrentOrganizationInfos";
import Divider from "./Divider";

import {SidebarContext} from "../../../../../SidebarContext";

function OrganizationSelectorMenuContent(props) {
    const [filteredOrganizations, setFilteredOrganizations] = useState([]);
    const [search, setSearch] = useState(null);

    const { currentOrganization, memberOrganizations, currentMember, isMobile} = useContext(SidebarContext);

    useEffect(() => {
        setFilteredOrganizations(moveSelectedOrganizationToFirst(memberOrganizations));
    }, [memberOrganizations]);

    useEffect(() => {
        if (!search) {
            setFilteredOrganizations(memberOrganizations);
        } else {
            setFilteredOrganizations(filterOrganizationsBySearch())
        }
    }, [search])

    function moveSelectedOrganizationToFirst(organizations) {
        const index = organizations.findIndex(organization => organization.id === currentOrganization.id);

        if (index !== -1) {
            const [organizationToMove] = organizations.splice(index, 1);
            organizations.unshift(organizationToMove);
        }

        return organizations;
    }

    function filterOrganizationsBySearch() {
        return memberOrganizations.filter((organization) => organization.name.toLowerCase().includes(search.toLowerCase()))
    }

    return (
        <div>
            <div>
                {!isMobile && (
                    <CurrentOrganizationInfos organization={currentOrganization} member={currentMember} />
                )}
                <Divider />
                <SearchBar
                    autoFocus
                    onChange={(value) => setSearch(value)}
                    customPlaceholder={'sidebar.search.organization.label'}
                    style={{
                        marginTop: isMobile ? '0px' : '12px',
                        marginBottom: isMobile ? '24px' : '20px',
                        ...!isMobile && {
                            padding: '12px'
                        }
                    }}
                />
                <div style={{
                    paddingRight: '12px',
                    paddingLeft: '12px'
                }}>
                    <SidebarHeadingTitle>
                        <FormattedMessage id='sidebar.organization.title' />
                    </SidebarHeadingTitle>
                </div>
            </div>

            <div style={{
                width: isMobile ? '100%' : '320px',
                ...!isMobile && {
                    overflowY: 'auto',
                    padding: '12px',
                }
            }}>
                {!filteredOrganizations.length ? (
                    <NoOrganizationFound />
                ) : (
                    <OrganizationList organizations={filteredOrganizations} />
                )}
            </div>
        </div>
    );
}

export default OrganizationSelectorMenuContent;
